export const authUrls = {
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  forgotPassword: '/forgot-password',
  confirmEmail: '/confirm-account',
}
